import { formatMoney } from '../../components/utilities'

const Customizations = {

  // Configura exibição do valor individual de cada personalização
  handleIndividualPrices: function() {
    const customs = document.querySelectorAll('[data-custom-option]')

    customs.forEach(custom => {
      const options = custom.querySelectorAll('[data-customization]')
      const displayValue = custom.querySelector('[data-value]')
      options.forEach(option => {
        option.addEventListener('change', () => {

          // Exibe o valor conforme seleção
          const value = Number(option.getAttribute('data-customization-price'))
          if (displayValue) {
            if (value > 0) {
              option.checked ?
                displayValue.innerText = `+ ${formatMoney(value)}` :
                displayValue.innerText = ''
            } else {
              displayValue.innerText = ''
            }
          }
        })
      })
    })
  },

  // Marca a primeira opção das customizações que possuem mais de uma opção
  markFirstOption: function() {
    const customs = document.querySelectorAll('[data-custom-option]')
    customs.forEach(custom => {
      const inputs = custom.querySelectorAll('input[type="radio"], input[type="checkbox"]')
      if (inputs.length > 1) {
        custom.querySelector(`[for="${inputs[0].id}"]`).click()
      }
    })
  },

  init: function() {
    this.handleIndividualPrices()
    this.markFirstOption()
  }
}

export default Customizations
